import { useCallback, useEffect, useState } from 'react'
import { acceptDailyOverride, fetchTodayProtocol, rejectDailyOverride } from './getTodayProtocol'
import type { TodayProtocolResponse } from './dailyOverrideTypes'

export function useTodayProtocol(enabled = true) {
  const [todayProtocol, setTodayProtocol] = useState<TodayProtocolResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [overrideBusy, setOverrideBusy] = useState(false)

  const refresh = useCallback(async () => {
    if (!enabled) {
      setLoading(false)
      return
    }
    setLoading(true)
    const { data, error } = await fetchTodayProtocol()
    if (error) console.error('fetchTodayProtocol:', error)
    setTodayProtocol(data ?? null)
    setLoading(false)
  }, [enabled])

  useEffect(() => {
    void refresh()
  }, [refresh])

  const acceptOverride = useCallback(async (): Promise<string | null> => {
    if (!todayProtocol?.override?.id) return null
    setOverrideBusy(true)
    const err = await acceptDailyOverride(todayProtocol.override.id)
    setOverrideBusy(false)
    if (err) return err
    await refresh()
    return null
  }, [todayProtocol?.override?.id, refresh])

  const rejectOverride = useCallback(async (): Promise<string | null> => {
    if (!todayProtocol?.override?.id) return null
    setOverrideBusy(true)
    const err = await rejectDailyOverride(todayProtocol.override.id)
    setOverrideBusy(false)
    if (err) return err
    await refresh()
    return null
  }, [todayProtocol?.override?.id, refresh])

  return {
    todayProtocol,
    loading,
    overrideBusy,
    refresh,
    acceptOverride,
    rejectOverride,
  }
}
